import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import logo from '../assets/exactapage-logo-lightbg.svg';

const Navbar = () => {
    const { user, logout } = useAuth();
    const isSuperAdmin = user && user.is_super_admin;

    const handleLogout = () => {
        logout();
        // No need to navigate - protected route will handle redirection
    };

    return (
        <nav className="bg-white p-4">
            <div className="container mx-auto flex justify-between">
                <div className="text-white text-lg font-bold">
                    <Link to="/" className="hover:opacity-80">
                        <img src={logo} alt="Exactapage" className="h-8" />
                    </Link>
                </div>
                <div>
                    <Link to="/organizations" className="text-gray-800 hover:text-black hover:bg-gray-100 px-3 py-2 rounded-md transition-all duration-200">Organizations</Link>
                    {isSuperAdmin && (
                        <Link to="/users" className="text-gray-800 hover:text-black hover:bg-gray-100 px-3 py-2 rounded-md ml-2 transition-all duration-200">Users</Link>
                    )}
                    <button
                        onClick={handleLogout}
                        className="text-gray-800 hover:text-black hover:bg-gray-100 px-3 py-2 rounded-md ml-2 cursor-pointer transition-all duration-200"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
